<app-header></app-header>

<ion-content
  id="all-deals"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <!-- DESKTOP -->
  <div
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    data-cy="rebate-hero-banner-section"
    class="rebate-hero-banner"
  >
    <div data-cy="background-overlay" class="background-overlay"></div>
    <ion-grid [fixed]="true">
      <ion-row class="rebate-hero-row" data-cy="rebate-hero-title-row">
        <ion-col size="12">
          <ion-text
            id="rebate-hero-text"
            data-cy="rebate-hero-title-text"
            [innerHTML]="'i18n.rebatesPage.usFoodsIncentives' | translate"
          ></ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <ion-grid>
    <ion-row>
      <ion-col
        size="12"
        *ngIf="!!selectedIncentiveProgram && !!currentWeek && (currentWeek.totalSpend > 0 || !isRebateActive)"
      >
        <ion-card>
          <ion-card-header>
            <div class="rebate-title-container">
              <div class="rebate-title">{{cardTitleText | translate}}</div>
              <div class="rebate-title-date">
                {{'i18n.rebatesPage.cardValidThrough' | translate}}
                <span class="date">{{rebateEndDate | date:"MMMM d,yyyy"}}</span>
              </div>
            </div>
            <div
              *ngIf="this.platformService.platformType === this.platformService.platformEnum.mobile"
              class="horizontal-divider"
            ></div>
          </ion-card-header>
          <ion-card-content class="rebates-card-content">
            <div class="on-pace-earn-section" *ngIf="isRebateActive">
              <div class="on-pace-earn-title-container">
                <div class="on-pace-earn-title">
                  {{'i18n.rebatesPage.cardYoureOnPaceToEarn' | translate}}
                </div>
                <div class="on-pace-earn-value">
                  {{selectedIncentiveProgram.toDateAgrTotal |
                  formatCurrencyAndDecimalPipe:'1.0-0'}}
                </div>
              </div>
              <div
                class="on-pace-earn-remaining"
                *ngIf="partnerTakeoutOptions.includes(selectedIncentiveProgram.icmTakeoutOption)"
              >
                {{'i18n.rebatesPage.cardOfPossible' | translate}}
                <span class="amount"
                  >{{selectedIncentiveProgram.maxEarn |
                  formatCurrencyAndDecimalPipe:'1.0-0'}}</span
                >
              </div>
              <div
                class="on-pace-earn-remaining"
                *ngIf="!partnerTakeoutOptions.includes(selectedIncentiveProgram.icmTakeoutOption)"
              >
                {{'i18n.rebatesPage.cardTotalSpendToDate' | translate}}
                <span class="amount"
                  >{{currentSpend | formatCurrencyAndDecimalPipe:'1.0-0'}}</span
                >
              </div>
              <div class="weeks-left-chip">
                {{'i18n.rebatesPage.cardWeeksRemaining' | translate: {weeksLeft:
                currentWeek.weeksLeft, totalWeeks: TOTAL_WEEKS} }}
              </div>
            </div>
            <div *ngIf="!isRebateActive" class="rebate-ended-banner">
              <div
                class="rebate-ended-congrats-banner"
                *ngIf="wasRebateReached"
              >
                <ion-img
                  src="assets/images/rebates-congrats-icon.svg"
                ></ion-img>
                <div class="rebates-congrats-text">
                  <div class="rebates-congrats-text-title">
                    <div>{{'i18n.rebatesPage.congratsTitle' | translate}}</div>
                    <div>{{congratsSubtitle}}</div>
                  </div>
                  <div class="rebates-congrats-amount-text">
                    {{selectedIncentiveProgram.toDateAgrTotal |
                    formatCurrencyAndDecimalPipe:'1.0-0'}}
                  </div>
                  <div
                    class="rebates-congrats-max-earn-text"
                    *ngIf="partnerTakeoutOptions.includes(selectedIncentiveProgram.icmTakeoutOption)"
                  >
                    {{'i18n.rebatesPage.congratsMaxEarn' | translate}}
                    {{selectedIncentiveProgram.maxEarn |
                    formatCurrencyAndDecimalPipe:'1.0-0'}}
                  </div>
                  <div
                    class="rebates-congrats-max-earn-text"
                    *ngIf="!partnerTakeoutOptions.includes(selectedIncentiveProgram.icmTakeoutOption)"
                  >
                    {{'i18n.rebatesPage.totalSpend' | translate}} {{currentSpend
                    | formatCurrencyAndDecimalPipe:'1.0-0'}}
                  </div>
                </div>
              </div>
              <div class="rebate-ended-banner-text" *ngIf="!wasRebateReached">
                <div class="rebate-ended-banner-text-title">
                  {{goalNotReachedLabel}}
                </div>
                <app-usf-chip
                  [type]="chipType"
                  [textColor]="'#B6B6B6'"
                  [backgroundColor]="'#F3F3F3'"
                  class="rebate-ended-banner-chip"
                >
                  {{"i18n.rebatesPage.cardEndedChip" | translate}}
                </app-usf-chip>
              </div>
            </div>
            <div
              class="progress-bar-section"
              [ngClass]="{'ended-success': !isRebateActive && wasRebateReached}"
              *ngIf="partnerTakeoutOptions.includes(selectedIncentiveProgram.icmTakeoutOption)"
            >
              <div class="progress-bar-section-title">
                <span *ngIf="isRebateActive">
                  {{'i18n.rebatesPage.cardCurrentSpend' | translate}}
                </span>
                <span *ngIf="!isRebateActive && !wasRebateReached">
                  {{'i18n.rebatesPage.totalSpend' | translate}}
                </span>
              </div>
              <div
                class="progress-bar-container"
                [ngClass]="{'pending': !wasRebateReached, 'ended': !isRebateActive}"
              >
                <ion-progress-bar
                  mode="determinate"
                  [value]="barProgress"
                ></ion-progress-bar>
                <span
                  class="progress-bar-current-spend"
                  [ngStyle]="barProgress > (isMobile ? 0.2 : 0.1) 
                    ? {'right': (1 - (this.barProgress < 1 ? this.barProgress : 1)) * 100 + '%'} 
                    : {'left': (this.barProgress + (this.isMobile ? 0.05 : 0.02)) * 100 + '%', 'color': 'var(--ion-color-gray-60)'}"
                  ><span class="amount"
                    ><span *ngIf="!isRebateActive && wasRebateReached"
                      >{{'i18n.rebatesPage.totalSpend' | translate}} </span
                    >{{currentSpend |
                    formatCurrencyAndDecimalPipe:'1.0-0'}}</span
                  ></span
                >
                <span
                  *ngIf="isRebateActive || !wasRebateReached"
                  class="progress-bar-arrow"
                  [ngStyle]="{'left': 'calc(' + minSpendPercent + '% - 3.26rem)'}"
                  [ngClass]="{'completed': currentSpend >= minSpend}"
                >
                  <span
                    class="min-spend-label"
                    *ngIf="isRebateActive || !wasRebateReached"
                  >
                    {{'i18n.rebatesPage.cardMinSpend' | translate}}
                    <span class="amount">{{minSpend | shortCurrencyPipe}}</span>
                  </span>
                  <div class="progress-bar-arrow-icon"></div>
                  <div class="progress-bar-arrow-line"></div>
                </span>
                <span
                  class="progress-bar-arrow progress-bar-max-arrow"
                  [ngClass]="{'completed': currentSpend >= maxSpend}"
                >
                  <span class="amount">{{maxSpend | shortCurrencyPipe:1}}</span>
                  <div class="progress-bar-arrow-icon"></div>
                  <div
                    class="progress-bar-arrow-line"
                    [ngClass]="{'completed': currentSpend >= maxSpend}"
                  ></div>
                </span>
              </div>
              <div
                class="progress-bar-on-pace-earn-section"
                *ngIf="isRebateActive || !wasRebateReached"
              >
                {{'i18n.rebatesPage.cardEarnUpTo' | translate}}
                <span class="amount"
                  >{{selectedIncentiveProgram.maxEarn |
                  formatCurrencyAndDecimalPipe:'1.0-0'}}</span
                >
              </div>
            </div>
            <ng-container
              *ngIf="isRebateActive && !partnerTakeoutOptions.includes(selectedIncentiveProgram.icmTakeoutOption)"
            >
              <div class="swiper-slider">
                <div
                  [ngClass]="[
                    'arrow-slider',
                    'previous-arrow',
                    swiperRef?.swiper.isBeginning ? 'swiper-button-disabled' : '',
                  ]"
                  (click)="swiperRef?.swiper.slidePrev()"
                >
                  <ion-icon
                    slot="icon-only"
                    name="chevron-back-circle"
                    data-cy="swiper-back-icon"
                  >
                  </ion-icon>
                </div>
                <swiper-container
                  #swiperRef
                  slides-per-view="auto"
                  navigation-prev-el=".previous-arrow"
                  navigation-next-el=".next-arrow"
                  observer="true"
                  observe-parents="true"
                  resize-observer="true"
                  no-swiping="true"
                  [speed]="0"
                  (init)="setInitialWeek($event.detail[0])"
                >
                  <swiper-slide
                    *ngFor="let week of sortedWeeklyRebates; trackBy: trackByIndex; let index = index"
                    [ngClass]="platformType === PlatformEnum.desktop ? 'desktop' : 'touch'"
                    class="swiper-no-swiping"
                  >
                    <div class="week-spend-container">
                      <div class="week-spend-title">
                        {{'i18n.rebatesPage.cardWeek' | translate: {week: (index
                        + 1)} }}
                      </div>
                      <div class="week-spend-value">
                        <div class="this-week-spend">
                          <div class="amount">
                            {{week.weekSpend |
                            formatCurrencyAndDecimalPipe:'1.0-0'}}
                            <ng-container *ngIf="week.spentMore">
                              <ion-img
                                src="assets/icon/rebates-increase-arrow.svg"
                              ></ion-img>
                            </ng-container>
                          </div>
                          <div class="label">
                            {{'i18n.rebatesPage.cardThisWeekSpend' | translate}}
                          </div>
                        </div>
                        <div class="vertical-divider"></div>
                        <div class="current-rebate-value">
                          <div class="amount">
                            {{week.rebateAmount|
                            formatCurrencyAndDecimalPipe:'1.0-0'}}
                          </div>
                          <div class="label">
                            {{ selectedIncentiveProgram?.icmTakeoutPercentage ??
                            0 }}% {{'i18n.rebatesPage.cardCurrentRebate' |
                            translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper-container>
                <div
                  [ngClass]="[
                    'arrow-slider',
                    'next-arrow',
                    swiperRef?.swiper.isEnd ? 'swiper-button-disabled' : '',
                  ]"
                  (click)="swiperRef?.swiper.slideNext()"
                >
                  <ion-icon
                    slot="icon-only"
                    name="chevron-forward-circle"
                    data-cy="forward-swiper-icon"
                  ></ion-icon>
                </div>
              </div>
            </ng-container>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" *ngIf="isRebateActive">
        <div class="create-order-banner">
          <div class="create-order-banner-content">
            <ion-img
              id="create-order-banner-img"
              src="assets/images/rebates-create-order-icon.svg"
            ></ion-img>
            <span>
              <div
                *ngIf="createOrderBoxTitle"
                class="create-order-banner-title"
              >
                {{createOrderBoxTitle}}
              </div>
              <div class="create-order-banner-text">{{createOrderBoxText}}</div>
            </span>
          </div>
          <div class="create-order-button">
            <ion-button class="usf-fill-green-button" (click)="createOrder()">
              {{createOrderButtonText}}
            </ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="rebate-disclaimer">
          {{'i18n.rebatesPage.rebatesDisclaimer' | translate}}
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="this.platformService.platformType === this.platformService.platformEnum.mobile"
    >
      <ion-col size="12">
        <div class="rebate-tiles-title">
          {{'i18n.rebatesPage.getMoreDeals' | translate}}
        </div>

        <div class="tile-container">
          <app-payment-tile-mobile
            [title]="'i18n.rebatesPage.dealsForYou' | translate"
            (actionClickEmitter)="getMoreDeals()"
          ></app-payment-tile-mobile>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="this.platformService.platformType === this.platformService.platformEnum.mobile"
    >
      <ion-col size="12">
        <div class="rebate-tiles-title">
          {{'i18n.rebatesPage.haveQuestions' | translate}}
        </div>
        <div class="tile-container">
          <app-payment-tile-mobile
            [title]="'i18n.rebatesPage.agreementDetails' | translate"
            (actionClickEmitter)="showAgreementDetails()"
          ></app-payment-tile-mobile>
          <app-payment-tile-mobile
            [title]="'i18n.rebatesPage.incentiveFAQs' | translate"
            (actionClickEmitter)="showIncentiveFAQs()"
          ></app-payment-tile-mobile>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="this.platformService.platformType !== this.platformService.platformEnum.mobile"
    >
      <ion-col class="icon-tile-container" size="12">
        <app-icon-tile
          [icon]="'assets/images/rebates-deals-icon.svg'"
          [iconBackgroundColor]="'#395A11'"
          [title]="'i18n.rebatesPage.dealsForYou' | translate"
          [description]="'i18n.rebatesPage.dealsForYouDescription' | translate"
          (ellipsisClickEventEmitter)="getMoreDeals()"
        ></app-icon-tile>
        <app-icon-tile
          [icon]="'assets/images/rebates-agreement-icon.svg'"
          [iconBackgroundColor]="'#56821F'"
          [title]="'i18n.rebatesPage.agreementDetails' | translate"
          [description]="'i18n.rebatesPage.agreementDetailsDescription' | translate"
          (ellipsisClickEventEmitter)="showAgreementDetails()"
        ></app-icon-tile>
        <app-icon-tile
          [icon]="'assets/images/rebates-faq-icon.svg'"
          [iconBackgroundColor]="'#BEC063'"
          [title]="'i18n.rebatesPage.incentiveFAQs' | translate"
          [description]="'i18n.rebatesPage.incentiveFAQsDescription' | translate"
          (ellipsisClickEventEmitter)="showIncentiveFAQs()"
        ></app-icon-tile>
      </ion-col>
    </ion-row>
  </ion-grid>

  <app-footer></app-footer>
</ion-content>
